const compatModules = {};import * as Mod1 from "./discourse/initializers/oauth2-basic-admin-plugin-configuration-nav";
compatModules["discourse/initializers/oauth2-basic-admin-plugin-configuration-nav"] = Mod1;

export * as discourse$initializers$oauth2__basic__admin__plugin__configuration__nav$$__module from "./discourse/initializers/oauth2-basic-admin-plugin-configuration-nav";
export {
default as discourse$initializers$oauth2__basic__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/oauth2-basic-admin-plugin-configuration-nav";
export default compatModules;
